import { createAppSelector, RootState } from "../configureStore";
import type { ItemsState } from "../reducers/items";

const stateSelector = (state: RootState) => state.items;

export const getItem = (state: RootState, name: string) => state.items[name];

export const makeItemSelector = () =>
  createAppSelector(
    stateSelector,
    (_: RootState, name: string) => name,
    (items: ItemsState, name: string) => items[name],
  );
